/* Mittsu: keep the sample colour aligned with the selected bulk-tile colour. */
(() => {
  if (window.__mittsuSampleColourSync) return;
  window.__mittsuSampleColourSync = true;

  const normalize = value => (value || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
  const sampleBlock = () => document.querySelector('main sample-product#order-a-sample');
  let syncEpoch = 0;
  let syncingSample = false;

  function tileColour() {
    const block = sampleBlock();
    if (!block) return '';
    const selected = document.querySelector('main input[type="radio"][name$="-option1"]:checked');
    const label = selected && document.querySelector(`label[for="${CSS.escape(selected.id)}"]`);
    return label?.querySelector('span')?.textContent.trim()
      || label?.textContent.trim()
      || block.dataset.tileColour
      || '';
  }

  function renderState(block, colour) {
    const select = block.querySelector('select[id^="sample-product-select-"]');
    const button = block.querySelector('button[data-sample-form-submit]');
    const status = block.querySelector('[data-sample-colour-status]');
    if (!select || !button || !status) return;

    const selected = select.selectedOptions[0];
    const sampleColour = selected?.dataset.sampleColour || '';
    let message = '';

    if (!selected || selected.disabled || !selected.value) {
      message = colour
        ? `A sample in ${colour} is currently unavailable. Choose another available sample colour if you wish.`
        : 'This sample is currently unavailable.';
    } else if (colour && normalize(sampleColour) !== normalize(colour)) {
      message = `You selected a ${sampleColour} sample. The bulk tile above is ${colour}.`;
    }

    button.disabled = !selected || selected.disabled || !selected.value;
    if (!button.disabled) {
      const caption = button.querySelector('span');
      if (caption && caption.textContent.trim() === 'Sold out') caption.textContent = 'Add sample to cart';
    }
    status.textContent = message;
    status.hidden = !message;
  }

  function syncFromTile() {
    const block = sampleBlock();
    if (!block) return;
    const select = block.querySelector('select[id^="sample-product-select-"]');
    if (!select) return;

    const colour = tileColour();
    const matching = [...select.options].find(option =>
      normalize(option.dataset.sampleColour) === normalize(colour)
    );

    if (matching && select.value !== matching.value) {
      select.value = matching.value;
      syncingSample = true;
      try {
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } finally {
        syncingSample = false;
      }
    }

    const status = block.querySelector('[data-sample-colour-status]');
    if (!matching && status) {
      select.selectedIndex = -1;
      status.textContent = `A matching sample for ${colour || 'this tile'} is unavailable. Choose an available sample colour if you wish.`;
      status.hidden = false;
      const button = block.querySelector('button[data-sample-form-submit]');
      if (button) button.disabled = true;
      return;
    }
    renderState(block, colour);
  }

  function scheduleSync() {
    const epoch = ++syncEpoch;
    [0, 120, 450, 1100].forEach(delay =>
      setTimeout(() => {
        if (epoch === syncEpoch) syncFromTile();
      }, delay)
    );
  }

  document.addEventListener('change', event => {
    if (event.target.matches('main input[type="radio"][name$="-option1"]')) {
      scheduleSync();
    } else if (event.target.matches('main sample-product select[id^="sample-product-select-"]')) {
      if (!syncingSample) ++syncEpoch;
      renderState(sampleBlock(), tileColour());
    }
  }, true);
  document.addEventListener('variant:change', scheduleSync);
  document.addEventListener('product:variant-change', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('main sample-product form')) return;
    const option = form.querySelector('select[id^="sample-product-select-"]')?.selectedOptions[0];
    if (!option || option.disabled || !option.value) {
      event.preventDefault();
      event.stopImmediatePropagation();
      syncFromTile();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }
})();
